import {downloadTemplate, exportData, importData, pageInfo, summary} from './../api';
import {listCarrier, listDest, listProject, listShipper} from "../../../../api";

const income = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    exportDataObj: null,
    downloadTemplateObj: null,
    importDataObj: null,
    shipperObj: null,
    summaryObj: null,
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    EXPORT_DATA(state, data) {
      state.exportDataObj = data;
    },
    DOWNLOAD_TEMPLATE(state, data) {
      state.downloadTemplateObj = data;
    },
    IMPORT_DATA(state, data) {
      state.importDataObj = data;
    },
    LIST_SHIPPER(state, data) {
      state.shipperObj = data.obj;
    },
    LIST_CARRIER(state, data) {
      state.carrierObj = data.obj;
    },
    LIST_PROJECT(state, data) {
      state.projectObj = data.obj;
    },
    LIST_DEST(state, data) {
      state.destObj = data.obj;
    }, SUMMARY(state, data) {
      state.summaryObj = data.obj;
    },
  },
  actions: {
    //查询
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //导出文件
    async exportData({commit}, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    //下载模板
    async downloadTemplate({commit}, obj) {
      let resp = await downloadTemplate(obj);
      commit('DOWNLOAD_TEMPLATE', resp);
    },
    //导入数据
    async importData({commit}, obj) {
      let resp = await importData(obj);
      commit('IMPORT_DATA', resp);
    },
    //货主
    async listShipper({commit}, obj) {
      let resp = await listShipper(obj);
      commit('LIST_SHIPPER', resp);
    },
    //承运商
    async listCarrier({commit}, obj) {
      let resp = await listCarrier(obj);
      commit('LIST_CARRIER', resp);
    },
    //项目
    async listProject({commit}, obj) {
      let resp = await listProject(obj);
      commit('LIST_PROJECT', resp);
    },
    //收货方
    async listDest({commit}, obj) {
      let resp = await listDest(obj);
      commit('LIST_DEST', resp);
    },
    //汇总
    async summary({commit}, obj) {
      let resp = await summary(obj);
      commit('SUMMARY', resp);
    }
  }
}
export default income



// WEBPACK FOOTER //
// ./src/page/settlementFee/income/store/income.store.js